import buildUrl from 'modules/core/lib/buildUrl'

import { EmployeeMetaMap } from 'modules/employees/pages/BulkFixContractsPage/types'

export const LIMIT_AVATARS_TO_SHOW = 6

export default function generateAvatars(employeeIds: string[], targetEmployees: EmployeeMetaMap) {
  return employeeIds
    .map((employeeId) => targetEmployees[employeeId])
    .filter(Boolean)
    .sort((a, b) => a.name.localeCompare(b.name))
    .slice(0, LIMIT_AVATARS_TO_SHOW)
    .map((employee) => ({
      label: employee.name,
      url: employee.avatar ? buildUrl(employee.avatar) : '',
    }))
}
